var helperGetDateTime = require('./helperGetDateTime')
var helperGetYMD = require('./helperGetYMD')

function helperGetYMDTime (date) {
  return helperGetDateTime(helperGetYMD(date))
}

module.exports = helperGetYMDTime



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/date/helperGetYMDTime.js
// module id = 603
// module chunks = 106